import { Theme } from "@mui/material/styles";

import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        connector: {
            position: "absolute",
            height: "100%",
            backgroundColor: theme.palette.primary.main,
            width: 1,
        },
        dot: {
            position: "absolute",
            top: 7,
            left: -8,
            width: theme.spacing(2),
            height: theme.spacing(2),
            margin: 0,
            padding: 0,
            backgroundColor: theme.palette.common.white,
            zIndex: 1,
            borderWidth: "1px",
        },
        missingOppositeContent: {
            "&::before": {
                display: "none",
            },
        },
        highlighted: {
            background: `${theme.palette.others.cyan}40`,
        },
        dimmed: {
            opacity: 0.5,
        },
        timeLineContent: {
            display: "flex",
            flexDirection: "column",
            padding: `0 0 ${theme.spacing(1)} ${theme.spacing(2)}`,
        },
        positionContainer: {
            display: "flex",
            textAlign: "left",
        },
        timeLineContentDivider: {
            width: 2,
            margin: "3px 8px",
            backgroundColor: theme.palette.common.black,
        },
        timeLineContentDate: {
            display: "flex",
            color: theme.palette.primary.main,
            fontSize: "13px",
            fontWeight: 600,
        },
    })
);
